import type { Scope } from '@/features/saved-views/types';

export const savedViewsKeys = {
  /** Every scope — session teardown drops all cached lists/details at once. */
  all: ['saved-views'] as const,
  root: (scope: Scope) => ['saved-views', scope] as const,
  list: (scope: Scope) => [...savedViewsKeys.root(scope), 'list'] as const,
  detail: (scope: Scope, id: number) => [...savedViewsKeys.root(scope), 'detail', id] as const,
} as const;
